import { Link } from "react-router-dom";

const Unauthorized = () => {
  const userClaims = JSON.parse(localStorage.getItem("user-claims"));
  const isApprovedUser = userClaims?.isActive || false;
  const isHrManagerRole =
    userClaims?.roles.some((a) => a.name === "hr-manager") || false;

  return (
    <div
      className="d-flex justify-content-center align-items-center text-center my-3"
      style={{
        minHeight: "100vh",
        backgroundColor: "#fff",
        padding: "2rem",
      }}
    >
      <div>
        <h1 className="display-4 font-weight-bold">401</h1>
        <h4 className="mb-3" style={{ color: "#325ba6" }}>
          Unauthorized Response
        </h4>
        <p className="text-muted mb-4">
          You do not have permission to access this page.
        </p>
        {!isApprovedUser || isHrManagerRole ? (
          <Link to="/profile/edit" className="btn btn-primary">
            ← Go to Edit Profile
          </Link>
        ) : (
          <Link to="/landing-page" className="btn btn-primary">
            ← Go to Dashboard
          </Link>
        )}
      </div>
    </div>
  );
};

export default Unauthorized;
